function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m26.953 57.366a4.3493 4.3493 0 0 0 0-6.2863l-15.078-14.63 47.683-0.0311a4.4426 4.4426 0 1 0 0-8.8852l-47.687 0.0311 15.105-14.625a4.3493 4.3493 0 0 0 0-6.2863 4.6781 4.6781 0 0 0-6.5129 0l-16.438 15.931a13.048 13.048 0 0 0 0 18.85l16.438 15.931a4.6781 4.6781 0 0 0 6.4729 0z",
    fill: "currentColor",
    style: {
      strokeWidth: 4.4426
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f3652e6c.svg";
export { ForwardRef as ReactComponent };